import { render, staticRenderFns } from "./NovedadesRutaIndex.vue?vue&type=template&id=7bb4f72a"
import script from "./NovedadesRutaIndex.vue?vue&type=script&lang=js"
export * from "./NovedadesRutaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports